// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-book {
    border: 1px solid #6438b4;
    color: #fff;
    background-color: #6438b4;
    margin-left: 15px;
    margin-top: 15px;
    box-shadow: none;
}

.btn-book:hover {
    color: #6438b4;
    background-color: #fff;
}

.btn-book .hoverarrow {
    display: none;
}

.btn-book:hover .nohover {
    display: none;
}

.btn-book:hover .hoverarrow {
    display: inline-block;
    width: 21px;
}

.card {
    cursor: pointer;
    text-align: start;
    border-radius: 15px;
    height: 100%;
    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);
    border: 2px solid #ffffff;
    padding: 25px;
    margin-bottom: 10px;
    transition: all .2s ease-in-out;
}

.card.disabled {
    cursor: default;
    pointer-events: none;
    background-color: #e9ecef;
    border-color: #e9ecef;
}

.card h6 {
    text-transform: uppercase;
}

.card .s-n p {
    font-weight: 400;
    font-size: 16px;
    color: #5c5c5c;
    text-align: left;
}

.card .complete {
    position: absolute;
    right: 15px;
    top: 20px;
}

.card:hover:not(.disabled) {
    transform: scale(1.02);
    -webkit-transform: scale(1.02);
}

.card .s-n {
    padding: 20px;
    text-align: center;
}

.hero {
    padding: 30px 100px;
    text-align: center;
}

#agreement-Modal .modal-body {
    height: 65vh;
    overflow: auto;
}

ul li {
    list-style-position: inside;
    padding-left: 20px;
}

.sib {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}


@media (max-width: 1200px) {
    .hero .col-lg-4 {
        margin: 15px 0 !important;
    }
}

@media (max-width: 1500px) {
    .hero {
        padding: 40px 35px;
    }
}


@media (max-width: 420px) {
    .hero {
        padding: 40px 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/seller-onboarding/seller-onboarding.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kDAAkD;IAClD,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;;AAGA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;;AAGA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".btn-book {\n    border: 1px solid #6438b4;\n    color: #fff;\n    background-color: #6438b4;\n    margin-left: 15px;\n    margin-top: 15px;\n    box-shadow: none;\n}\n\n.btn-book:hover {\n    color: #6438b4;\n    background-color: #fff;\n}\n\n.btn-book .hoverarrow {\n    display: none;\n}\n\n.btn-book:hover .nohover {\n    display: none;\n}\n\n.btn-book:hover .hoverarrow {\n    display: inline-block;\n    width: 21px;\n}\n\n.card {\n    cursor: pointer;\n    text-align: start;\n    border-radius: 15px;\n    height: 100%;\n    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);\n    border: 2px solid #ffffff;\n    padding: 25px;\n    margin-bottom: 10px;\n    transition: all .2s ease-in-out;\n}\n\n.card.disabled {\n    cursor: default;\n    pointer-events: none;\n    background-color: #e9ecef;\n    border-color: #e9ecef;\n}\n\n.card h6 {\n    text-transform: uppercase;\n}\n\n.card .s-n p {\n    font-weight: 400;\n    font-size: 16px;\n    color: #5c5c5c;\n    text-align: left;\n}\n\n.card .complete {\n    position: absolute;\n    right: 15px;\n    top: 20px;\n}\n\n.card:hover:not(.disabled) {\n    transform: scale(1.02);\n    -webkit-transform: scale(1.02);\n}\n\n.card .s-n {\n    padding: 20px;\n    text-align: center;\n}\n\n.hero {\n    padding: 30px 100px;\n    text-align: center;\n}\n\n#agreement-Modal .modal-body {\n    height: 65vh;\n    overflow: auto;\n}\n\nul li {\n    list-style-position: inside;\n    padding-left: 20px;\n}\n\n.sib {\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n}\n\n\n@media (max-width: 1200px) {\n    .hero .col-lg-4 {\n        margin: 15px 0 !important;\n    }\n}\n\n@media (max-width: 1500px) {\n    .hero {\n        padding: 40px 35px;\n    }\n}\n\n\n@media (max-width: 420px) {\n    .hero {\n        padding: 40px 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
